import script from "./multipane.vue?vue&type=script&setup=true&lang=ts"
export * from "./multipane.vue?vue&type=script&setup=true&lang=ts"

import "./multipane.vue?vue&type=style&index=0&id=65329665&lang=scss"

const __exports__ = script;

export default __exports__